<template>
<div
  :class="`wallet-workpackage-cut-out `"
  >
  <div
    :class="`cut-out-none ${color}`"
    v-if="status_index === -1"
    />
    <div
      :class="`cut-out-left ${color} ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}`"
      v-if="status_index > 0"
      :style="`width: ${status_index * 16.666666}%`"
    />
    <div
      :class="`cut-out-center`"
      v-if="status_index > -1"
      >
      <div
        class="cut-out-inset-shadow"
        :style="`
          ${status_index === 0?'width: calc(100% + 3px); margin-left: -3px':''}
          ${status_index === status_count-1?'width: calc(100% + 3px)':''}
          `"
        />
    </div>
    <div
      :class="`cut-out-right ${color} ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}`"
      v-if="status_index > -1 && status_index < status_count-1"
      :style="`width: ${(status_count -1 - status_index) * 16.666666}%`"
    />
</div>
</template>
<script>
export default {
  props: ['color', 'status_index', 'status_count'],
  data: () => ({

  }),
}
</script>
<style>
  .wallet-workpackage-cut-out {
    display: flex;
    height: 20px;
    overflow: hidden;
    padding-top: 3px;
    margin-top: -3px;
    cursor: pointer;
  }
  .cut-out-none {
    width: 100%;
    border-radius: 10px 10px 0px 0px;
    box-shadow: 0px 0px 3px 0px #000000;

  }
  .cut-out-left {
    border-radius: 10px 0px 0px 0px;
    box-shadow: 0px 0px 3px 0px #000000;
  }
  .cut-out-center {
    width: 16.66%;
    height: 17px;
    overflow: hidden;
  }
  .cut-out-inset-shadow {
    box-shadow: inset 0px 0px 3px 0px #000000;
    height: 23px;
    margin-top: -6px;
  }
  .cut-out-right {
    border-radius: 0px 10px 0px 0px;
    box-shadow: 0px 0px 3px 0px #000000;
  }
</style>
